
export interface AuthFormData {
  email: string;
  password: string;
  name?: string;
}

export interface AuthFormProps {
  mode: 'login' | 'register';
  onSubmit: (data: AuthFormData) => Promise<void>;
  isLoading: boolean;
  error: string | null;
}

export class AuthForm {
  private container: HTMLElement;
  private props: AuthFormProps;
  private form: HTMLFormElement | null = null;

  constructor(container: HTMLElement, props: AuthFormProps) {
    this.container = container;
    this.props = props;
    this.render();
  }

  private render(): void {
    const isLogin = this.props.mode === 'login';
    
    this.container.innerHTML = `
      <div class="auth-form">
        <div class="auth-header">
          <h2>${isLogin ? 'Iniciar Sesión' : 'Crear Cuenta'}</h2>
          <p>${isLogin ? 'Ingresa tus credenciales' : 'Completa el formulario para registrarte'}</p>
        </div>
        
        <form id="auth-form" class="form">
          ${!isLogin ? `
            <div class="form-group">
              <label for="name">Nombre completo</label>
              <input 
                type="text" 
                id="name" 
                name="name" 
                required 
                placeholder="Ingresa tu nombre completo"
              />
            </div>
          ` : ''}
          
          <div class="form-group">
            <label for="email">Correo electrónico</label>
            <input 
              type="email" 
              id="email" 
              name="email" 
              required 
              placeholder="tu@email.com"
            />
          </div>
          
          <div class="form-group">
            <label for="password">Contraseña</label>
            <input 
              type="password" 
              id="password" 
              name="password" 
              required 
              placeholder="••••••••"
              minlength="8"
            />
          </div>
          
          ${this.props.error ? `
            <div class="error-message">
              ${this.props.error}
            </div>
          ` : ''}
          
          <button 
            type="submit" 
            class="submit-btn"
            ${this.props.isLoading ? 'disabled' : ''}
          >
            ${this.props.isLoading ? 'Cargando...' : (isLogin ? 'Iniciar Sesión' : 'Crear Cuenta')}
          </button>
        </form>
        
        <div class="auth-footer">
          <p>
            ${isLogin ? '¿No tienes cuenta?' : '¿Ya tienes cuenta?'}
            <button type="button" class="switch-mode-btn">
              ${isLogin ? 'Regístrate aquí' : 'Inicia sesión aquí'}
            </button>
          </p>
        </div>
      </div>
    `;

    this.form = this.container.querySelector('#auth-form') as HTMLFormElement;
    this.attachEventListeners();
  }

  private attachEventListeners(): void {
    if (!this.form) return;

    this.form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const formData = new FormData(this.form!);
      const data: AuthFormData = {
        email: formData.get('email') as string,
        password: formData.get('password') as string,
      };

      if (this.props.mode === 'register') {
        data.name = formData.get('name') as string;
      }

      try {
        await this.props.onSubmit(data);
      } catch (error) {
        console.error('Error en formulario:', error);
      }
    });

    // Botón para cambiar entre login y registro
    const switchBtn = this.container.querySelector('.switch-mode-btn');
    if (switchBtn) {
      switchBtn.addEventListener('click', () => {
        const newMode = this.props.mode === 'login' ? 'register' : 'login';
        this.updateProps({ ...this.props, mode: newMode, error: null });
      });
    }
  }

  public updateProps(newProps: Partial<AuthFormProps>): void {
    this.props = { ...this.props, ...newProps };
    this.render();
  }
}
